module.exports = __webpack_public_path__ + "img/icon-building-dark-old.a0f8c12e.svg";